import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from 'components/ui';

import styles from './segments.module.scss';
import dictionary from 'config/dictionary';

const ConfirmationHeader = props => {
  const { segmentName } = props;

  return (
    <>
      <SvgIcon className={styles.warningIcon} name="warning_triangle" />
      <h3 className={styles.confirmationTitle}>
        {dictionary.segments.confirmation.title}
      </h3>
      {segmentName ? (
        <p className={styles.confirmationProduct}>
          You have selected
          <br />
          <strong>{segmentName}</strong>.
        </p>
      ) : null}
    </>
  );
};

ConfirmationHeader.propTypes = {
  segmentName: PropTypes.string.isRequired
};

export default ConfirmationHeader;
